import WikiView from './components/theme/Views/WikiView';
import SolrSearchView from './components/theme/Views/SolrSearchView';
import NewsItemView from './components/theme/Views/NewsItemView';
import NewsContainerView from './components/theme/Views/NewsContainerView/index';
import EditUserView from './components/manage/Views/EditUserView';
import UserListingView from './components/theme/Views/UserListingView';
import DashboardView from './components/theme/Views/DashboardView';
import reducers from './reducers';

const applyConfig = (config) => {
  config.views.contentTypesViews.Wiki = WikiView;
  config.views.contentTypesViews['News Item'] = NewsItemView;
  config.views.contentTypesViews.NewsContainer = NewsContainerView;
  // the site root has the layout dashboard_view (hornundhorn.policy), and
  // Volto picks a view by layout before it looks at the content type
  config.views.layoutViews.dashboard_view = DashboardView;
  config.views.layoutViewsNamesMapping.dashboard_view = 'Dashboard';
  // fallback for a site root without a layout, e.g. from plone.restapi 9
  config.views.contentTypesViews['Plone Site'] = DashboardView;

  config.addonRoutes.push({ path: '/search', component: SolrSearchView });
  config.addonRoutes.push({
    path: '/edit-user/:userId',
    component: EditUserView,
  });
  config.addonRoutes.push({ path: '/nutzer', component: UserListingView });

  config.addonReducers = { ...config.addonReducers, ...reducers };

  config.settings.bookmarkgroupmapping = {
    manual: 'Manuals and HowTos',
    releasenote: 'Release Notes',
    default_search: 'Search',
    default_nogroup: 'Miscellaneous',
  };
  config.settings.notSupportedBrowsers = [];
  config.settings.supportedLanguages = ['de'];
  // Volto 19 no longer reads this setting, express-middleware/language does
  config.settings.defaultLanguage = 'de';

  return config;
};

export default applyConfig;
